import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@store/index";
import { DocumentState } from "@pdfViewer/models";

export const documentNameSelector = (state: RootState): DocumentState["documentName"] => state.pdfViewer.documentName;
export const documentIdSelector = (state: RootState): DocumentState["documentId"] => state.pdfViewer.documentId;
export const documentURLSelector = (state: RootState): DocumentState["documentUrl"] => state.pdfViewer.documentUrl;
export const openDocumentDialogFlagSelector = (state: RootState): DocumentState["isOpenDocumentDialog"] =>
  state.pdfViewer.isOpenDocumentDialog;

export const pdfViewerSelector = createSelector(
  documentNameSelector,
  documentIdSelector,
  documentURLSelector,
  openDocumentDialogFlagSelector,
  (documentName, documentId, documentUrl, isOpenDocumentDialog) => ({
    documentName,
    documentId,
    documentUrl,
    isOpenDocumentDialog,
  })
);
